import React, { useEffect, useRef, useState } from 'react';
import styled, { ThemeProvider } from 'styled-components';
import { hasElementScrollbar } from '../../../utils/misc';
import { DefaultTheme } from '../../Themes';
import TableHeader from './TableHeader';
import TableBody from './TableBody';
const StyledTableContainer = styled.div `
  display: flex;
  flex-direction: column;
`;
const Table = ({ rowData, columns, className, headerClassName, headerRowClassName, headerCellClassName, bodyClassName, rowClassName, cellClassName, height, onHeaderCellClick, onRowClick, onCellClick, buildBodyRowStyles, defaultCellValue, noDataMessage, theme = DefaultTheme, }) => {
    const containerRef = useRef(null);
    const [headerPaddingRight, setHeaderPaddingRight] = useState(0);
    useEffect(() => {
        // If the body has a scrollbar, we apply a `padding-right` on the header
        // to align the header and body cells.
        if (hasElementScrollbar(containerRef.current)) {
            const { offsetWidth, clientWidth } = containerRef.current;
            setHeaderPaddingRight(offsetWidth - clientWidth);
        }
    }, []);
    return (React.createElement(ThemeProvider, { theme: theme },
        React.createElement(StyledTableContainer, { className: className, style: { height } },
            React.createElement(TableHeader, { columns: columns, className: headerClassName, headerRowClassName: headerRowClassName, headerCellClassName: headerCellClassName, onCellClick: onHeaderCellClick, style: { paddingRight: headerPaddingRight } }),
            React.createElement(TableBody, { ref: containerRef, rowData: rowData, columns: columns, className: bodyClassName, rowClassName: rowClassName, cellClassName: cellClassName, onRowClick: onRowClick, onCellClick: onCellClick, buildBodyRowStyles: buildBodyRowStyles, defaultCellValue: defaultCellValue, noDataMessage: noDataMessage }))));
};
export default Table;
